import React from "react";
import { Sparkles } from "lucide-react";

export default function AiPageShell({ title, subtitle, children, actions, wide = false }) {
    return (
        <div className={`p-4 lg:p-8 mx-auto space-y-6 ${wide ? "max-w-[1400px]" : "max-w-6xl"}`}>
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
                <div>
                    <div className="flex items-center gap-2 text-[#D4AF37] text-[10px] font-bold uppercase tracking-[0.2em] mb-2">
                        <Sparkles className="h-3.5 w-3.5" />
                        Yapay Zeka · Akıl
                    </div>
                    <h1 className="font-display text-2xl lg:text-3xl gold-text">{title}</h1>
                    {subtitle ? (
                        <p className="text-sm text-slate-400 mt-2 max-w-2xl">{subtitle}</p>
                    ) : null}
                </div>
                {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
            </div>
            {children}
        </div>
    );
}
